// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"64":"offer-catalog-routing","884":"admin","908":"telephony-routing"}[chunkId] || chunkId) + "." + {"64":"d6775afe","333":"64993993","462":"2807a0d8","658":"2807a0d8","884":"9c8cc6bf","908":"27471b7b"}[chunkId] + ".css";
};